import { render } from "./SectionFive.vue?vue&type=template&id=51a548f5&scoped=true"
const script = {}

import "./SectionFive.vue?vue&type=style&index=0&id=51a548f5&scoped=true&lang=css"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a548f5"]])

export default __exports__